import { useEffect } from 'react'

import {
  ConnectMapToList,
  DrawArea,
  InspectPinMode,
  Map as MainMap,
  MapLayer,
  removeEditableArea,
} from '@/map'

export function Map() {
  useEffect(
    () => () => {
      removeEditableArea()
    },
    [],
  )

  return (
    <MainMap selectionContext="crud" selectionCategory="regions" mapId="ww-map">
      <InspectPinMode mode="none" />

      <MapLayer uid="order" />
      <MapLayer uid="depot" />
      <MapLayer uid="region" interactive />
      <MapLayer uid="roadSegment" />
      <MapLayer uid="geofence" visible={false} />
      <MapLayer uid="routePolyline" />
      <MapLayer uid="place" />
      <MapLayer uid="device" />
      <MapLayer uid="vehicle" />

      <ConnectMapToList category="regions" />

      <DrawArea />
    </MainMap>
  )
}
